import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import CommuteRoundedIcon from '@mui/icons-material/CommuteRounded';
import DeliveryDiningRoundedIcon from '@mui/icons-material/DeliveryDiningRounded';
import DiamondRoundedIcon from '@mui/icons-material/DiamondRounded';
import DirectionsBusRoundedIcon from '@mui/icons-material/DirectionsBusRounded';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import ElectricCarRoundedIcon from '@mui/icons-material/ElectricCarRounded';
import EmojiTransportationRoundedIcon from '@mui/icons-material/EmojiTransportationRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FlightRoundedIcon from '@mui/icons-material/FlightRounded';
import FlashOnRoundedIcon from '@mui/icons-material/FlashOnRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import LuggageRoundedIcon from '@mui/icons-material/LuggageRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import LocalTaxiRoundedIcon from '@mui/icons-material/LocalTaxiRounded';
import NightlifeRoundedIcon from '@mui/icons-material/NightlifeRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import SafetyCheckRoundedIcon from '@mui/icons-material/SafetyCheckRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarsRoundedIcon from '@mui/icons-material/StarsRounded';
import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';
import TimelapseRoundedIcon from '@mui/icons-material/TimelapseRounded';
import TwoWheelerRoundedIcon from '@mui/icons-material/TwoWheelerRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import type { ElementType } from 'react';

export interface ServiceTierIconOption {
  key: string;
  label: string;
  keywords: string[];
  Icon: ElementType;
}

export const SERVICE_TIER_ICON_OPTIONS: ServiceTierIconOption[] = [
  { key: 'StarBorderRounded', label: 'Star Border Rounded', keywords: ['tier', 'standard', 'star'], Icon: StarBorderRoundedIcon },
  { key: 'WorkspacePremiumRounded', label: 'Workspace Premium Rounded', keywords: ['premium', 'badge', 'tier'], Icon: WorkspacePremiumRoundedIcon },
  { key: 'DiamondRounded', label: 'Diamond Rounded', keywords: ['luxury', 'diamond', 'vip'], Icon: DiamondRoundedIcon },
  { key: 'LocalTaxiRounded', label: 'Local Taxi Rounded', keywords: ['taxi', 'car', 'transport'], Icon: LocalTaxiRoundedIcon },
  { key: 'DirectionsCarRounded', label: 'Directions Car Rounded', keywords: ['car', 'vehicle', 'transport'], Icon: DirectionsCarRoundedIcon },
  { key: 'AirportShuttleRounded', label: 'Airport Shuttle Rounded', keywords: ['shuttle', 'van', 'airport'], Icon: AirportShuttleRoundedIcon },
  { key: 'DirectionsBusRounded', label: 'Directions Bus Rounded', keywords: ['bus', 'microbus', 'omnibus'], Icon: DirectionsBusRoundedIcon },
  { key: 'TwoWheelerRounded', label: 'Two Wheeler Rounded', keywords: ['motorcycle', 'bike', 'delivery'], Icon: TwoWheelerRoundedIcon },
  { key: 'DeliveryDiningRounded', label: 'Delivery Dining Rounded', keywords: ['delivery', 'express', 'urgent'], Icon: DeliveryDiningRoundedIcon },
  { key: 'LocalShippingRounded', label: 'Local Shipping Rounded', keywords: ['cargo', 'shipping', 'delivery'], Icon: LocalShippingRoundedIcon },
  { key: 'EmojiTransportationRounded', label: 'Emoji Transportation Rounded', keywords: ['transport', 'fleet', 'vehicle'], Icon: EmojiTransportationRoundedIcon },
  { key: 'CommuteRounded', label: 'Commute Rounded', keywords: ['commute', 'trip', 'city'], Icon: CommuteRoundedIcon },
  { key: 'ElectricCarRounded', label: 'Electric Car Rounded', keywords: ['electric', 'eco', 'green'], Icon: ElectricCarRoundedIcon },
  { key: 'AutoAwesomeRounded', label: 'Auto Awesome Rounded', keywords: ['premium', 'experience', 'special'], Icon: AutoAwesomeRoundedIcon },
  { key: 'VerifiedRounded', label: 'Verified Rounded', keywords: ['verified', 'quality', 'trusted'], Icon: VerifiedRoundedIcon },
  { key: 'SafetyCheckRounded', label: 'Safety Check Rounded', keywords: ['safety', 'secure', 'check'], Icon: SafetyCheckRoundedIcon },
  { key: 'SecurityRounded', label: 'Security Rounded', keywords: ['security', 'shield', 'safe'], Icon: SecurityRoundedIcon },
  { key: 'ShieldRounded', label: 'Shield Rounded', keywords: ['shield', 'protection', 'safe'], Icon: ShieldRoundedIcon },
  { key: 'BoltRounded', label: 'Bolt Rounded', keywords: ['fast', 'instant', 'quick'], Icon: BoltRoundedIcon },
  { key: 'FlashOnRounded', label: 'Flash On Rounded', keywords: ['flash', 'speed', 'urgent'], Icon: FlashOnRoundedIcon },
  { key: 'RocketLaunchRounded', label: 'Rocket Launch Rounded', keywords: ['rocket', 'express', 'fast'], Icon: RocketLaunchRoundedIcon },
  { key: 'LocalFireDepartmentRounded', label: 'Local Fire Department Rounded', keywords: ['hot', 'priority', 'urgent'], Icon: LocalFireDepartmentRoundedIcon },
  { key: 'AttachMoneyRounded', label: 'Attach Money Rounded', keywords: ['price', 'fare', 'economy'], Icon: AttachMoneyRoundedIcon },
  { key: 'BusinessCenterRounded', label: 'Business Center Rounded', keywords: ['corporate', 'business', 'executive'], Icon: BusinessCenterRoundedIcon },
  { key: 'FlightRounded', label: 'Flight Rounded', keywords: ['airport', 'flight', 'travel'], Icon: FlightRoundedIcon },
  { key: 'LuggageRounded', label: 'Luggage Rounded', keywords: ['luggage', 'bags', 'travel'], Icon: LuggageRoundedIcon },
  { key: 'Groups2Rounded', label: 'Groups 2 Rounded', keywords: ['group', 'passengers', 'capacity'], Icon: Groups2RoundedIcon },
  { key: 'PersonRounded', label: 'Person Rounded', keywords: ['single', 'person', 'passenger'], Icon: PersonRoundedIcon },
  { key: 'EventAvailableRounded', label: 'Event Available Rounded', keywords: ['schedule', 'booking', 'calendar'], Icon: EventAvailableRoundedIcon },
  { key: 'ScheduleRounded', label: 'Schedule Rounded', keywords: ['time', 'scheduled', 'clock'], Icon: ScheduleRoundedIcon },
  { key: 'AccessTimeRounded', label: 'Access Time Rounded', keywords: ['time', 'duration', 'clock'], Icon: AccessTimeRoundedIcon },
  { key: 'TimelapseRounded', label: 'Timelapse Rounded', keywords: ['duration', 'trip', 'time'], Icon: TimelapseRoundedIcon },
  { key: 'StarsRounded', label: 'Stars Rounded', keywords: ['stars', 'premium', 'quality'], Icon: StarsRoundedIcon },
  { key: 'ThumbUpRounded', label: 'Thumb Up Rounded', keywords: ['recommended', 'top', 'good'], Icon: ThumbUpRoundedIcon },
  { key: 'FavoriteRounded', label: 'Favorite Rounded', keywords: ['favorite', 'best', 'special'], Icon: FavoriteRoundedIcon },
  { key: 'NightlifeRounded', label: 'Nightlife Rounded', keywords: ['night', 'event', 'vip'], Icon: NightlifeRoundedIcon },
  { key: 'PublicRounded', label: 'Public Rounded', keywords: ['international', 'global', 'world'], Icon: PublicRoundedIcon },
];

const normalize = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const filterServiceTierIcons = (query: string): ServiceTierIconOption[] => {
  const normalizedQuery = normalize(query || '');

  if (!normalizedQuery) {
    return SERVICE_TIER_ICON_OPTIONS;
  }

  return SERVICE_TIER_ICON_OPTIONS.filter((option) => {
    const searchable = [option.key, option.label, ...option.keywords]
      .map(normalize)
      .join(' ');

    return searchable.includes(normalizedQuery);
  });
};

export const getServiceTierIconByKey = (key?: string | null): ServiceTierIconOption | undefined => {
  if (!key) {
    return undefined;
  }

  const normalizedKey = String(key).trim().replace(/Icon$/, '');
  return SERVICE_TIER_ICON_OPTIONS.find((option) => option.key === normalizedKey);
};
